import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import VueHomeDesign1 from '@/components/layout/home-design-1.vue';
import {HttpService} from '@/services/api';
import {LoginInfo} from '@/store/auth/auth.types';
import {AuthEnum} from '@/store/auth/auth.enum';
import {ServiceRead, ServiceTransactionInitState} from '@/store/service-transaction/service-transaction.types';
import PaymentJobRunningComponent from '@/components/payment/payment-job-running.vue';
import {Member, MemberInitState} from '@/store/member/member.types';

@Component({
  components: {
    HomeDesign1: VueHomeDesign1,
    PaymentJobRunningComponent
  }
})
export default class HomeComponent extends Vue {

  @State('member') memberInitState!: MemberInitState;
  @State('serviceTransaction') serviceTransactionInitState!: ServiceTransactionInitState;
  @Action('_getServiceTransactionInviteList', {namespace: 'serviceTransaction'}) getServiceTransactionInviteList!: () => Promise<void>;
  @Action('_getServiceTransactionHistoryList', {namespace: 'serviceTransaction'}) getServiceTransactionHistoryList!: () => Promise<void>;
  @Action('_getMemberById', {namespace: 'member'}) getMemberById!: (payload: string) => Promise<void>;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_renewToken', {namespace: 'auth'}) renewToken!: () => Promise<void>;
  @Action('_updateMember', {namespace: 'member'}) updateMember!: (payload: Member) => Promise<void>;
  public loginInfo = {} as LoginInfo;
  public notification = false;
  public notificationActivity = false;
  public modalTerm = false;
  public member = {} as Member;
  public condition = false;

  public loginAlready: boolean = false;

  async mounted() {
   await this.Loading(true);
    this.loginAlready = (await HttpService.Authorization());
    if (this.loginAlready) {
      this.renew();
      this.loginInfo = JSON.parse(localStorage.getItem(AuthEnum.Auth) as string) as LoginInfo;
      await this.getMemberById(this.loginInfo.id);
      this.member = this.memberInitState.profile
      if(!this.member.conditions) {
          this.modalTerm = true;
      }
      await this.Loading(false);

      await this.getServiceTransactionInviteList();
      if (this.serviceTransactionInitState.serviceTransactions.length !== 0) {
        this.notification = true;
      }
      await this.getServiceTransactionHistoryList();
      if (this.serviceTransactionInitState.serviceTransactionHistory.length !== 0) {
        let count = this.serviceTransactionInitState.serviceTransactionHistory.filter((row) => row.read === ServiceRead.Unread)
        if(count.length !== 0) {
          this.notificationActivity = true;
        }
      }
    }

    await this.Loading(false);


  }

  routerPath(path: string) {
    this.$router.push(path).then();
  }

  public renew() {
    this.renewToken().then();
  }

  redirectSearch(type: ('1' | '2')) {
    this.renew();
    this.$router.push({
      path: 'search',
      query: {
        serviceType: type
      }
    })
  }

  async logOut() {
    this.Loading(true);
    localStorage.removeItem(AuthEnum.Auth);
    localStorage.removeItem(AuthEnum.weakPassword);
    location.reload();
  }

  async clickCondition (e: boolean) {
    this.condition = e
    this.member.conditions = this.condition
  }
  async acceptCondition () {
    delete this.member.createdBy;
    delete this.member.modifiedBy;
    delete this.member.deletedBy;
    delete this.member.createdAt;
    delete this.member.modifiedAt;
    delete this.member.deletedAt;
    delete this.member.personEmergencies;
    delete this.member.password;
    // @ts-ignore
    delete this.member.branch;
    // @ts-ignore
    delete this.member.community;
    // @ts-ignore
    delete this.member.bondsman;
    await this.updateMember(this.member);
    await this.getMemberById(this.loginInfo.id);
    this.modalTerm = false;
  }

}
